// import React, { useState, useEffect } from "react";
// import PageTitle from "../../Common/PageTitle";
// import FormFieldSet from "../../FormFields/FormFieldSet";
// import ColumnSelector from "./ColumnSelector";
// import Button from "../../Buttons/Button";
// import { keyToTitle } from "../../../utils";
// import { showToast } from "../../Toast/Toast";
// import LoopFieldsSet from "../../FormFields/LoopFieldsSet";
// import { v4 as uuidv4 } from "uuid";
// import useFormHandler from "../../Validations/useFormHandler";
// import { getColumnDataType, determineColumnDataType } from "./tableUtils";
// import getFilterOperatorsByDataType from "./tableUtils/filterOperators";

// const TableDrawerData = ({
//   columns = [],
//   rows = [],
//   userId,
//   tableId,
//   showSlNo,
//   fixedCol,
//   onFilterUpdate,
//   serverFiltering = false,
//   onServerFilterChange = null,
// }) => {
//   const updateColunms = (columns) => {
//     return columns.map((column) => ({
//       key: column.key,
//       label: column.label,
//     }));
//   };

//   const [listName, setListName] = useState("");
//   const [options, setOptions] = useState(["1"]);
//   const [selectedColumns, setSelectedColumns] = useState([]);
//   const [existingConfigs, setExistingConfigs] = useState([]);
//   const [isAddNewMode, setIsAddNewMode] = useState(false);
//   const [activeConfigId, setActiveConfigId] = useState(null);
//   const [originalConfigName, setOriginalConfigName] = useState("");
//   console.log("existing configs", existingConfigs);

//   const colunmsCleanKeys = columns
//     .filter((column) => column.key || column.labelKey)
//     .map((column) => ({
//       key: column.key,
//       label: column.label,
//       labelKey: column.labelKey || null,
//       dataType: column.dataType || null,
//     }));

//   const columnDataTypesComplete = colunmsCleanKeys.map((column) => ({
//     key: column.key,
//     labelKey: column.labelKey || null,
//     dataType: column.dataType || getColumnDataType(column, rows),
//   }));

//   console.log("columnDataTypesComplete", columnDataTypesComplete);
//   useEffect(() => {
//     const configToUpdate = existingConfigs.find(
//       (config) => config.configName === originalConfigName
//     );

//     if (configToUpdate) {
//       const updatedConfig = {
//         ...configToUpdate,
//         configName: listName,
//         isActive: options.includes("2"),
//         isDefault: options.includes("1"),
//         columns: selectedColumns,
//         allFilterConditions: formData.filterConditions,
//         anyFilterConditions: formData.anyConditions,
//         updatedDate: new Date().toISOString(),
//       };

//       const index = existingConfigs.findIndex(
//         (config) => config.id === configToUpdate.id
//       );

//       if (index !== -1) {
//         existingConfigs[index] = updatedConfig;

//         localStorage.setItem(
//           `tableConfig_${tableId}_${userId}`,
//           JSON.stringify(existingConfigs)
//         );
//       }
//     }
//   }, [selectedColumns]);

//   const initialFilterConditions = [
//     {
//       id: uuidv4(),
//       filterColunm: "",
//       operator: "",
//       value: [],
//       dataType: "string",
//     },
//   ];

//   const initialAnyConditions = [
//     {
//       id: uuidv4(),
//       filterColunm: "",
//       operator: "",
//       value: [],
//       dataType: "string",
//     },
//   ];

//   const { formData, errors, handleChange, validateAllFields, setFormData } =
//     useFormHandler({
//       filterConditions: initialFilterConditions,
//       anyConditions: initialAnyConditions,
//     });

//   // Add/Remove functions for All Conditions (AND logic)
//   const addFilterCondition = () => {
//     const newCondition = {
//       id: uuidv4(),
//       filterColunm: "",
//       operator: "",
//       value: [],
//       dataType: "string",
//     };
//     setFormData({
//       ...formData,
//       filterConditions: [...formData.filterConditions, newCondition],
//     });
//   };

//   const removeFilterCondition = (id) => {
//     setFormData({
//       ...formData,
//       filterConditions: formData.filterConditions.filter(
//         (condition) => condition.id !== id
//       ),
//     });
//   };

//   // Add/Remove functions for Any Conditions (OR logic)
//   const addAnyCondition = () => {
//     const newCondition = {
//       id: uuidv4(),
//       filterColunm: "",
//       operator: "",
//       value: [],
//       dataType: "string",
//     };
//     setFormData({
//       ...formData,
//       anyConditions: [...formData.anyConditions, newCondition],
//     });
//   };

//   const removeAnyCondition = (id) => {
//     setFormData({
//       ...formData,
//       anyConditions: formData.anyConditions.filter(
//         (condition) => condition.id !== id
//       ),
//     });
//   };

//   useEffect(() => {
//     loadExistingConfigs();

//     const handleConfigUpdate = (e) => {
//       if (
//         tableId &&
//         e.detail.tableId === tableId &&
//         e.detail.userId === userId
//       ) {
//         loadExistingConfigs();
//       }
//     };

//     window.addEventListener("tableConfigUpdated", handleConfigUpdate);

//     return () => {
//       window.removeEventListener("tableConfigUpdated", handleConfigUpdate);
//     };
//   }, [tableId, userId]);

//   // const loadExistingConfigs = () => {

//   //   const existingConfigStr = localStorage.getItem(
//   //     `tableConfig_${tableId}_${userId}`
//   //   );

//   //   if (existingConfigStr) {
//   //     try {
//   //       const parsedConfig = JSON.parse(existingConfigStr);
//   //       const configs = Array.isArray(parsedConfig)
//   //         ? parsedConfig
//   //         : [parsedConfig];
//   //       setExistingConfigs(configs);

//   //       // Load active config data on initial load
//   //       const activeConfig = configs.find((config) => config.isActive);
//   //       if (activeConfig && !isAddNewMode) {
//   //         loadConfigData(activeConfig);
//   //         setActiveConfigId(activeConfig.id);
//   //       }
//   //     } catch (error) {
//   //       console.error("Error parsing existing table config:", error);
//   //       setExistingConfigs([]);
//   //     }
//   //   } else {
//   //     setExistingConfigs([]);
//   //   }
//   // };

//   const loadExistingConfigs = () => {
//     const existingConfigStr = localStorage.getItem(
//       `tableConfig_${tableId}_${userId}`
//     );

//     if (existingConfigStr) {
//       try {
//         const parsedConfig = JSON.parse(existingConfigStr);
//         const configs = Array.isArray(parsedConfig)
//           ? parsedConfig
//           : [parsedConfig];
//         setExistingConfigs(configs);

//         // Find active config (if any)
//         const activeConfig = configs.find((config) => config.isActive);

//         if (activeConfig) {
//           // Load active config data only if one exists
//           loadConfigData(activeConfig);
//           setActiveConfigId(activeConfig.id);
//           setIsAddNewMode(false);
//         } else {
//           // No active config -> don't auto-load, wait for user selection
//           setActiveConfigId(null);
//           setIsAddNewMode(false);
//           setListName("");
//           setOptions(["1"]);
//           setSelectedColumns([]);
//           setFormData({
//             filterConditions: initialFilterConditions,
//             anyConditions: initialAnyConditions,
//           });
//         }
//       } catch (error) {
//         console.error("Error parsing existing table config:", error);
//         setExistingConfigs([]);
//         setIsAddNewMode(true); // show add-new screen if parsing fails
//       }
//     } else {
//       // No configs at all -> show Add New mode
//       setExistingConfigs([]);
//       setIsAddNewMode(true);
//       setListName("");
//       setOptions(["1"]);
//       setSelectedColumns([]);
//       setFormData({
//         filterConditions: initialFilterConditions,
//         anyConditions: initialAnyConditions,
//       });
//     }
//   };

//   // Function to load configuration data into the form
//   const loadConfigData = (config) => {
//     setListName(config.configName);
//     // setSelectedColumns(config.columns || []);
//     const validColumns = (config.columns || []).filter(
//       (col) => col.key && col.key.trim() !== ""
//     );

//     setSelectedColumns(validColumns);

//     // Set options based on config properties
//     const optionValues = [];
//     if (config.isDefault) optionValues.push("1");
//     if (config.isActive) optionValues.push("2");
//     setOptions(optionValues.length > 0 ? optionValues : []);

//     // Load filter conditions
//     setFormData({
//       filterConditions:
//         config.allFilterConditions && config.allFilterConditions.length > 0
//           ? config.allFilterConditions
//           : initialFilterConditions,
//       anyConditions:
//         config.anyFilterConditions && config.anyFilterConditions.length > 0
//           ? config.anyFilterConditions
//           : initialAnyConditions,
//     });

//     // keep track of original name so updates can match the right config
//     setOriginalConfigName(config.configName);
//   };

//   // Function to handle "Add New" button click
//   const onAddNewConfig = () => {
//     setIsAddNewMode(true);
//     setListName("");
//     setOptions(["1"]);
//     setSelectedColumns([]);
//     setActiveConfigId(null);
//     setOriginalConfigName("");

//     setFormData({
//       filterConditions: initialFilterConditions,
//       anyConditions: initialAnyConditions,
//     });
//   };

//   const toCamelCase = (str) => {
//     return str
//       .trim()
//       .replace(/\s+/g, " ")
//       .split(" ")
//       .map((word, index) => {
//         if (index === 0) {
//           return word.toLowerCase();
//         }
//         return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
//       })
//       .join("");
//   };

//   const onSaveConfigList = () => {
//     if (!listName.trim()) {
//       showToast("Please enter a configuration name", "warning");
//       return;
//     }

//     if (selectedColumns.length === 0) {
//       showToast("Please select at least one column", "warning");
//       return;
//     }

//     const camelCaseListName = toCamelCase(listName);

//     const existingConfigStr = localStorage.getItem(
//       `tableConfig_${tableId}_${userId}`
//     );
//     let existingConfigs = [];

//     if (existingConfigStr) {
//       try {
//         const parsedConfig = JSON.parse(existingConfigStr);
//         existingConfigs = Array.isArray(parsedConfig)
//           ? parsedConfig
//           : [parsedConfig];

//         const isDuplicate = existingConfigs.some(
//           (config) =>
//             config.configName.toLowerCase() === camelCaseListName.toLowerCase()
//         );

//         if (isDuplicate) {
//           showToast(
//             `Configuration with name "${camelCaseListName}" already exists`,
//             "error"
//           );
//           return;
//         }
//       } catch (error) {
//         console.error("Error parsing existing table config:", error);
//       }
//     }

//     const isDefault = options.includes("1");
//     const isActive = false; // New configs should not be active by default

//     const newConfig = {
//       id: Date.now(),
//       configName: camelCaseListName,
//       columns: selectedColumns,
//       allFilterConditions: formData.filterConditions,
//       anyFilterConditions: formData.anyConditions,
//       isActive: isActive, // Always false for new configs
//       isDefault,
//       createdDate: new Date().toISOString(),
//     };

//     // Update existing configs - don't change their active status
//     const updatedConfigs = existingConfigs.map((config) => ({
//       ...config,
//       isDefault: isDefault ? false : config.isDefault,
//       // Keep existing active status unchanged
//     }));

//     updatedConfigs.push(newConfig);

//     localStorage.setItem(
//       `tableConfig_${tableId}_${userId}`,
//       JSON.stringify(updatedConfigs)
//     );

//     if (onFilterUpdate) {
//       onFilterUpdate();
//     }

//     const event = new CustomEvent("tableConfigUpdated", {
//       detail: { tableId, userId },
//     });
//     window.dispatchEvent(event);

//     // After saving, exit add new mode and load the active config
//     setIsAddNewMode(false);
//     loadExistingConfigs();
//     showToast("Configuration saved successfully", "success");
//   };

//   const deleteConfig = (configToDelete) => {
//     const existingConfigStr = localStorage.getItem(
//       `tableConfig_${tableId}_${userId}`
//     );
//     let existingConfigs = [];

//     if (existingConfigStr) {
//       try {
//         const parsedConfig = JSON.parse(existingConfigStr);
//         existingConfigs = Array.isArray(parsedConfig)
//           ? parsedConfig
//           : [parsedConfig];
//       } catch (error) {
//         console.error("Error parsing existing table config:", error);
//       }
//     }

//     const updatedConfigs = existingConfigs.filter(
//       (config) => config.id !== configToDelete.id
//     );

//     localStorage.setItem(
//       `tableConfig_${tableId}_${userId}`,
//       JSON.stringify(updatedConfigs)
//     );

//     if (onFilterUpdate) {
//       onFilterUpdate();
//     }

//     const event = new CustomEvent("tableConfigUpdated", {
//       detail: { tableId, userId },
//     });
//     window.dispatchEvent(event);

//     if (serverFiltering && onServerFilterChange && configToDelete.isActive) {
//       const newActiveConfig = updatedConfigs.find((config) => config.isActive);
//       if (newActiveConfig) {
//         onServerFilterChange({
//           allFilterConditions: newActiveConfig.allFilterConditions || [],
//           anyFilterConditions: newActiveConfig.anyFilterConditions || [],
//           columns: newActiveConfig.columns || [],
//           configName: newActiveConfig.configName,
//           configId: newActiveConfig.id,
//         });
//       }
//     }

//     loadExistingConfigs();
//     showToast("Configuration deleted successfully", "success");
//   };

//   // const activeConfig = (configToActive) => {
//   //   const existingConfigStr = localStorage.getItem(
//   //     `tableConfig_${tableId}_${userId}`
//   //   );
//   //   let existingConfigs = [];

//   //   if (existingConfigStr) {
//   //     try {
//   //       const parsedConfig = JSON.parse(existingConfigStr);
//   //       existingConfigs = Array.isArray(parsedConfig)
//   //         ? parsedConfig
//   //         : [parsedConfig];
//   //     } catch (error) {
//   //       console.error("Error parsing existing table config:", error);
//   //     }
//   //   }

//   //   const updatedConfigs = existingConfigs.map((config) => ({
//   //     ...config,
//   //     isActive: false,
//   //   }));

//   //   const configToUpdate = updatedConfigs.find(
//   //     (config) => config.id === configToActive.id
//   //   );

//   //   if (configToUpdate) {
//   //     configToUpdate.isActive = true;

//   //     localStorage.setItem(
//   //       `tableConfig_${tableId}_${userId}`,
//   //       JSON.stringify(updatedConfigs)
//   //     );

//   //     if (onFilterUpdate) {
//   //       onFilterUpdate();
//   //     }

//   //     const event = new CustomEvent("tableConfigUpdated", {
//   //       detail: { tableId, userId },
//   //     });
//   //     window.dispatchEvent(event);

//   //     if (serverFiltering && onServerFilterChange) {
//   //       onServerFilterChange({
//   //         allFilterConditions: configToActive.allFilterConditions || [],
//   //         anyFilterConditions: configToActive.anyFilterConditions || [],
//   //         columns: configToActive.columns || [],
//   //         configName: configToActive.configName,
//   //         configId: configToActive.id,
//   //       });
//   //     }

//   //     // Load the newly activated config data
//   //     loadConfigData(configToActive);
//   //     setActiveConfigId(configToActive.id);
//   //     setIsAddNewMode(false);

//   //     loadExistingConfigs();
//   //     showToast("Configuration activated successfully", "success");
//   //   } else {
//   //     showToast("Configuration not found", "error");
//   //   }
//   // };
//   const activeConfig = (configToToggle) => {
//     const existingConfigStr = localStorage.getItem(
//       `tableConfig_${tableId}_${userId}`
//     );
//     let existingConfigs = [];

//     if (existingConfigStr) {
//       try {
//         const parsedConfig = JSON.parse(existingConfigStr);
//         existingConfigs = Array.isArray(parsedConfig)
//           ? parsedConfig
//           : [parsedConfig];
//       } catch (error) {
//         console.error("Error parsing existing table config:", error);
//       }
//     }

//     // Check current active status
//     const isCurrentlyActive = configToToggle.isActive;

//     // Toggle logic
//     const updatedConfigs = existingConfigs.map((config) => ({
//       ...config,
//       isActive: config.id === configToToggle.id ? !isCurrentlyActive : false,
//     }));

//     // Save back
//     localStorage.setItem(
//       `tableConfig_${tableId}_${userId}`,
//       JSON.stringify(updatedConfigs)
//     );

//     // Update local state
//     loadExistingConfigs();

//     // Dispatch update event
//     const event = new CustomEvent("tableConfigUpdated", {
//       detail: { tableId, userId },
//     });
//     window.dispatchEvent(event);

//     if (serverFiltering && onServerFilterChange) {
//       const newlyActiveConfig = updatedConfigs.find((c) => c.isActive);
//       onServerFilterChange(
//         newlyActiveConfig
//           ? {
//               allFilterConditions: newlyActiveConfig.allFilterConditions || [],
//               anyFilterConditions: newlyActiveConfig.anyFilterConditions || [],
//               columns: newlyActiveConfig.columns || [],
//               configName: newlyActiveConfig.configName,
//               configId: newlyActiveConfig.id,
//             }
//           : {
//               allFilterConditions: [],
//               anyFilterConditions: [],
//               columns: [],
//               configName: "",
//               configId: null,
//             }
//       );
//     }

//     if (isCurrentlyActive) {
//       showToast("Configuration deactivated successfully", "danger");
//     } else {
//       showToast("Configuration activated successfully", "success");
//     }
//   };

//   console.log("originalconfig", originalConfigName);

//   const onCancelChanges = () => {
//     // On cancel, reload the active config if present, otherwise clear
//     const activeConfig = existingConfigs.find((config) => config.isActive);
//     if (activeConfig) {
//       loadConfigData(activeConfig);
//       setActiveConfigId(activeConfig.id);
//       setIsAddNewMode(false);
//     } else {
//       setListName("");
//       setOptions(["1"]);
//       setSelectedColumns([]);
//       setFormData({
//         filterConditions: initialFilterConditions,
//         anyConditions: initialAnyConditions,
//       });
//       setActiveConfigId(null);
//       setOriginalConfigName("");
//       setIsAddNewMode(false);
//     }
//   };

//   const onUpdateConfigList = () => {
//     const existingConfigStr = localStorage.getItem(
//       `tableConfig_${tableId}_${userId}`
//     );

//     let existingConfigs = [];
//     if (existingConfigStr) {
//       try {
//         const parsedConfig = JSON.parse(existingConfigStr);
//         existingConfigs = Array.isArray(parsedConfig)
//           ? parsedConfig
//           : [parsedConfig];
//       } catch (error) {
//         console.error("Error parsing existing table config:", error);
//       }
//     }

//     const duplicateNameIndex = existingConfigs.findIndex(
//       (config) =>
//         config.configName === listName &&
//         config.configName !== originalConfigName
//     );

//     if (duplicateNameIndex !== -1) {
//       showToast(
//         "Configuration name already exists. Please choose a different name.",
//         "error"
//       );
//       return;
//     }

//     const configToUpdate = existingConfigs.find(
//       (config) => config.configName === originalConfigName
//     );

//     if (configToUpdate) {
//       const updatedConfig = {
//         ...configToUpdate,
//         configName: listName,
//         isActive: options.includes("2"),
//         isDefault: options.includes("1"),
//         columns: selectedColumns,
//         allFilterConditions: formData.filterConditions,
//         anyFilterConditions: formData.anyConditions,
//         updatedDate: new Date().toISOString(),
//       };

//       const index = existingConfigs.findIndex(
//         (config) => config.id === configToUpdate.id
//       );

//       if (index !== -1) {
//         existingConfigs[index] = updatedConfig;

//         localStorage.setItem(
//           `tableConfig_${tableId}_${userId}`,
//           JSON.stringify(existingConfigs)
//         );

//         const event = new CustomEvent("tableConfigUpdated", {
//           detail: { tableId, userId },
//         });
//         window.dispatchEvent(event);

//         if (serverFiltering && onServerFilterChange && updatedConfig.isActive) {
//           onServerFilterChange({
//             allFilterConditions: updatedConfig.allFilterConditions || [],
//             anyFilterConditions: updatedConfig.anyFilterConditions || [],
//             columns: updatedConfig.columns || [],
//             configName: updatedConfig.configName,
//             configId: updatedConfig.id,
//           });
//         }

//         loadExistingConfigs();
//         showToast("Configuration updated successfully", "success");
//         onCancelChanges();
//       } else {
//         showToast("Configuration not found", "error");
//       }
//     } else {
//       showToast("Configuration not found", "error");
//     }
//   };

//   const renderConditionFields = (condition, index, isAllConditions = true) => {
//     const conditionsArray = isAllConditions
//       ? formData.filterConditions
//       : formData.anyConditions;

//     return (
//       <>
//         <FormFieldSet
//           title="Column"
//           placeholder="Select Column"
//           type="select"
//           options={columns
//             .filter((col) => col.key)
//             .map((col) => ({
//               label: col.label,
//               value: col.labelKey || col.key,
//             }))}
//           value={condition.filterColunm || ""}
//           onChange={(value) => {
//             conditionsArray[index].filterColunm = value;
//             conditionsArray[index].filterValue = "";
//             conditionsArray[index].operator = "";

//             const selectedColumn =
//               columns.find((col) => (col.labelKey || col.key) === value) || {};

//             determineColumnDataType(
//               selectedColumn,
//               rows,
//               conditionsArray[index],
//               null
//             );

//             setFormData({ ...formData });
//           }}
//         />
//         <div>
//           <FormFieldSet
//             title="Operator"
//             placeholder="Select Operator"
//             type="select"
//             options={getFilterOperatorsByDataType(
//               conditionsArray[index].dataType
//             )}
//             value={condition.operator || ""}
//             onChange={(value) => {
//               conditionsArray[index].operator = value;
//               setFormData({ ...formData });
//             }}
//             disabled={!conditionsArray[index].dataType}
//           />
//         </div>
//         <div className="w-full">
//           <FormFieldSet
//             title="Value"
//             placeholder="Enter value"
//             type={(() => {
//               const dataType = conditionsArray[index].dataType;

//               switch (dataType) {
//                 case "date":
//                   return "datepicker";
//                 case "boolean":
//                   return "select";
//                 case "enum":
//                   return "select";
//                 case "array":
//                   return "select";
//                 case "number":
//                 case "integer":
//                 case "currency":
//                 case "percentage":
//                   return "text";
//                 case "email":
//                   return "text";
//                 case "url":
//                   return "text";
//                 case "phone":
//                   return "phone";
//                 default:
//                   return "text";
//               }
//             })()}
//             options={(() => {
//               const dataType = conditionsArray[index].dataType;
//               const selectedColumn =
//                 columns.find(
//                   (col) =>
//                     (col.labelKey || col.key) ===
//                     conditionsArray[index].filterColunm
//                 ) || {};

//               if (dataType === "enum" && selectedColumn.dataValue) {
//                 return selectedColumn.dataValue;
//               }

//               if (dataType === "array") {
//                 if (Array.isArray(selectedColumn.dataValue)) {
//                   return selectedColumn.dataValue.map((item) => {
//                     if (
//                       item &&
//                       typeof item === "object" &&
//                       "label" in item &&
//                       "value" in item
//                     ) {
//                       return item;
//                     }

//                     const itemStr = String(item);
//                     const valueStr = itemStr.replace(/\s+/g, "_");

//                     return {
//                       label: itemStr,
//                       value: valueStr,
//                     };
//                   });
//                 }
//                 return selectedColumn.dataValue;
//               }

//               if (dataType === "boolean") {
//                 return [
//                   { label: "True", value: true },
//                   { label: "False", value: false },
//                 ];
//               }

//               return [];
//             })()}
//             value={
//               condition.filterValue ||
//               (conditionsArray[index].dataType === "array" ? [] : "")
//             }
//             onChange={(value) => {
//               conditionsArray[index].filterValue = value;
//               setFormData({ ...formData });
//             }}
//             disabled={!conditionsArray[index].operator}
//             multiple={conditionsArray[index].dataType === "array"}
//           />
//         </div>
//       </>
//     );
//   };

//   return (
//     <div className="grid grid-cols-[4fr_10fr] gap-10 w-full overflow-auto">
//       <div className="h-full overflow-auto shadow-2xl">
//         <div className="">
//           <div className="flex justify-between items-center px-3 py-2">
//             <PageTitle title="Column Configurations List" tag="h6" />
//             <Button
//               title="Add New"
//               icon="add"
//               size="sm"
//               variant="outlined"
//               onClick={onAddNewConfig}
//             />
//           </div>
//           <div className="mt-3 h-80 overflow-auto">
//             {existingConfigs.map((config, index) => {
//               return (
//                 <div
//                   key={index}
//                   className={`border-b border-gray-300 flex justify-between items-center py-1 px-3 ${
//                     config.id === activeConfigId && !isAddNewMode
//                       ? "bg-blue-100"
//                       : "bg-gray-100"
//                   }`}
//                 >
//                   <div className="flex-1 text-sm">
//                     {keyToTitle(config.configName)}
//                   </div>
//                   <div className="flex gap-1 items-center ">
//                     {/* {config.isActive ? (
//                       <span className="material-symbols-outlined text-success p-0.5">
//                         check_small
//                       </span>
//                     ) : (
//                       <Button
//                         variant="text"
//                         title="active"
//                         type="icon"
//                         icon="check_indeterminate_small"
//                         size="sm"
//                         color="dark"
//                         onClick={() => activeConfig(config)}
//                       />
//                     )} */}
//                     <Button
//                       variant="text"
//                       type="icon"
//                       icon={
//                         config.isActive
//                           ? "check_small"
//                           : "check_indeterminate_small"
//                       }
//                       size="sm"
//                       color={config.isActive ? "success" : "dark"}
//                       onClick={() => activeConfig(config)}
//                     />

//                     {config.isActive === false &&
//                       config.configName !== "defaultConfig" && (
//                         <>
//                           <Button
//                             variant="text"
//                             title="delete"
//                             type="icon"
//                             icon="delete"
//                             size="xs"
//                             color="danger"
//                             onClick={() => deleteConfig(config)}
//                           />
//                         </>
//                       )}
//                     {config.isActive &&
//                       config.configName !== "defaultConfig" && (
//                         <>
//                           {/* keep copy button if needed */}
//                           <Button
//                             variant="text"
//                             title="copy"
//                             type="icon"
//                             icon="content_copy"
//                             size="xs"
//                             color="danger"
//                           />
//                         </>
//                       )}
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//         </div>
//       </div>
//       <div className="flex flex-col gap-3  flex-1 overflow-hidden">
//         <div className="border border-gray-200 p-5 rounded-md">
//           <PageTitle
//             title={
//               isAddNewMode
//                 ? "Create New Column Configuration List"
//                 : "Active Configuration"
//             }
//             tag="h6"
//           />
//           <div className="grid grid-cols-6 gap-5 mt-3">
//             <div className="col-span-4">
//               <FormFieldSet
//                 type="text"
//                 placeholder="List Name"
//                 title="List Name"
//                 value={listName}
//                 onChange={setListName}
//                 // allow editing list name directly (update happens via Update button)
//                 disabled={false}
//               />
//             </div>
//             <div className="col-span-2">
//               <FormFieldSet
//                 title=""
//                 type="checkbox"
//                 options={[
//                   { label: "Set as Default", value: "1" },
//                   { label: "Set As Active", value: "2" },
//                 ]}
//                 multiple
//                 values={options}
//                 onChange={(values) => setOptions(values)}
//                 disabled={false}
//               />
//             </div>

//             <div className="col-span-6">
//               <ColumnSelector
//                 columns={colunmsCleanKeys}
//                 placeholder={"Select columns"}
//                 rounded={"rounded"}
//                 showSearch
//                 selectedColumns={selectedColumns}
//                 onChange={setSelectedColumns}
//                 // column selection should always be editable (no need to click edit)
//                 disabled={false}
//               />
//             </div>
//           </div>
//         </div>
//         <div className="flex flex-col flex-1 gap-3 overflow-auto">
//           {/* All Conditions - AND Logic */}
//           <div className="border border-gray-200 p-5 rounded-md ">
//             <PageTitle title="Search In" tag="h6" />
//             <LoopFieldsSet
//               title="All Conditions"
//               data={formData.filterConditions}
//               onAdd={addFilterCondition}
//               onRemove={removeFilterCondition}
//               minItems={1}
//               maxItems={5}
//               gridCols="grid-cols-[repeat(3,1fr)_0.5fr]"
//               renderFields={(condition, index) =>
//                 renderConditionFields(condition, index, true)
//               }
//               // allow editing conditions directly
//               disabled={false}
//             />
//           </div>

//           {/* Any Conditions - OR Logic */}
//           <div className="border border-gray-200 p-5 rounded-md">
//             <PageTitle title="Search In" tag="h6" />
//             <LoopFieldsSet
//               title="Any Condition"
//               data={formData.anyConditions}
//               onAdd={addAnyCondition}
//               onRemove={removeAnyCondition}
//               minItems={1}
//               maxItems={5}
//               gridCols="grid-cols-[repeat(3,1fr)_0.5fr]"
//               renderFields={(condition, index) =>
//                 renderConditionFields(condition, index, false)
//               }
//               disabled={false}
//             />
//           </div>
//         </div>
//         <div className="col-span-6 mb-4 mx-3 ">
//           {isAddNewMode ? (
//             <div className="flex justify-end gap-2">
//               <Button
//                 title={"Cancel"}
//                 icon={"close"}
//                 variant="text"
//                 onClick={() => {
//                   const activeConfig = existingConfigs.find(
//                     (config) => config.isActive
//                   );
//                   if (activeConfig) {
//                     loadConfigData(activeConfig);
//                     setActiveConfigId(activeConfig.id);
//                     setIsAddNewMode(false);
//                   } else {
//                     // Fallback if no active config exists
//                     onCancelChanges();
//                   }
//                 }}
//                 size="sm"
//                 color="black"
//               />
//               <Button
//                 title={"Save"}
//                 icon={"save"}
//                 onClick={onSaveConfigList}
//                 size="sm"
//               />
//             </div>
//           ) : (
//             activeConfigId && (
//               <div className="flex justify-end gap-2">
//                 {/* <Button
//                   title={"Cancel"}
//                   icon={"close"}
//                   variant="text"
//                   onClick={onCancelChanges}
//                   size="sm"
//                   color="black"
//                 /> */}
//                 <Button
//                   title={"Update"}
//                   icon={"save"}
//                   onClick={onUpdateConfigList}
//                   size="sm"
//                 />
//               </div>
//               // ) : (
//               //   <div className="flex gap-1 justify-end">
//               //     {/* Show nothing when there is no active config and not in add new mode */}
//               //   </div>
//             )
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default TableDrawerData;

import React, { useState, useEffect, useCallback } from "react";
import PageTitle from "../../Common/PageTitle";
import FormFieldSet from "../../FormFields/FormFieldSet";
import ColumnSelector from "./ColumnSelector";
import Button from "../../Buttons/Button";
import { keyToTitle } from "../../../utils";
import { showToast } from "../../Toast/Toast";
import LoopFieldsSet from "../../FormFields/LoopFieldsSet";
import { v4 as uuidv4 } from "uuid";
import useFormHandler from "../../Validations/useFormHandler";
// import { getColumnDataType, determineColumnDataType } from "./tableUtils";
import {
  getEnhancedColumnDataType,
  determineColumnDataTypeEnhanced,
} from "./tableUtils/typeDetection";
import getFilterOperatorsByDataType from "./tableUtils/filterOperators";

const SYSTEM_CONFIG_ID = "system-generated-config";
const SYSTEM_CONFIG_NAME = "systemGenerated";

const TableDrawerData = ({
  columns = [],
  rows = [],
  userId,
  tableId,
  showSlNo,
  fixedCol,
  onFilterUpdate,
  serverFiltering = false,
  onServerFilterChange = null,
  onDrawerClose,
}) => {
  const [listName, setListName] = useState("");
  const [options, setOptions] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [existingConfigs, setExistingConfigs] = useState([]);
  const [isAddNewMode, setIsAddNewMode] = useState(false);
  const [activeConfigId, setActiveConfigId] = useState(null);
  const [originalConfigName, setOriginalConfigName] = useState("");
  const [isSystemConfigActive, setIsSystemConfigActive] = useState(true);

  const colunmsCleanKeys = columns
    .filter((column) => column.key || column.labelKey)
    .map((column) => ({
      key: column.key,
      label: column.label,
      labelKey: column.labelKey || null,
      dataType: column.dataType || null,
    }));

  const columnDataTypesComplete = colunmsCleanKeys.map((column) => ({
    key: column.key,
    labelKey: column.labelKey || null,
    dataType: column.dataType || getEnhancedColumnDataType(column, rows),
  }));
  useEffect(() => {
    const configToUpdate = existingConfigs.find(
      (config) => config.configName === originalConfigName,
    );
    // CLEAN FILTER CONDITIONS BEFORE SAVING
    const cleanAll = (formData?.filterConditions || []).filter(
      (c) => c.filterColunm && c.operator,
    );

    const cleanAny = (formData?.anyConditions || []).filter(
      (c) => c.filterColunm && c.operator,
    );

    if (configToUpdate) {
      const updatedConfig = {
        ...configToUpdate,
        configName: listName,
        isActive: options.includes("2"),
        isDefault: options.includes("1"),
        columns: selectedColumns,
        allFilterConditions: cleanAll,
        anyFilterConditions: cleanAny,
        updatedDate: new Date().toISOString(),
      };

      const index = existingConfigs.findIndex(
        (config) => config.id === configToUpdate.id,
      );

      if (index !== -1) {
        existingConfigs[index] = updatedConfig;

        localStorage.setItem(
          `tableConfig_${tableId}_${userId}`,
          JSON.stringify(existingConfigs),
        );
      }
    }
  }, [selectedColumns]);

  const initialFilterConditions = [
    {
      id: uuidv4(),
      filterColunm: "",
      operator: "",
      value: [],
      dataType: "string",
    },
  ];

  const initialAnyConditions = [
    {
      id: uuidv4(),
      filterColunm: "",
      operator: "",
      value: [],
      dataType: "string",
    },
  ];

  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler({
      filterConditions: initialFilterConditions,
      anyConditions: initialAnyConditions,
    });

  const addFilterCondition = () => {
    const newCondition = {
      id: uuidv4(),
      filterColunm: "",
      operator: "",
      value: [],
      dataType: "string",
    };
    setFormData({
      ...formData,
      filterConditions: [...formData.filterConditions, newCondition],
    });
  };

  const removeFilterCondition = (id) => {
    setFormData({
      ...formData,
      filterConditions: formData.filterConditions.filter(
        (condition) => condition.id !== id,
      ),
    });
  };

  const addAnyCondition = () => {
    const newCondition = {
      id: uuidv4(),
      filterColunm: "",
      operator: "",
      value: [],
      dataType: "string",
    };
    setFormData({
      ...formData,
      anyConditions: [...formData.anyConditions, newCondition],
    });
  };

  const removeAnyCondition = (id) => {
    setFormData({
      ...formData,
      anyConditions: formData.anyConditions.filter(
        (condition) => condition.id !== id,
      ),
    });
  };

  // Initialize system config
  const initializeSystemConfig = useCallback(() => {
    const existingConfigStr = localStorage.getItem(
      `tableConfig_${tableId}_${userId}`,
    );

    let configs = [];
    if (existingConfigStr) {
      try {
        const parsedConfig = JSON.parse(existingConfigStr);
        configs = Array.isArray(parsedConfig) ? parsedConfig : [parsedConfig];
      } catch (error) {
        console.error("Error parsing existing table config:", error);
      }
    }

    // Check if system config exists
    const systemConfigExists = configs.find(
      (config) => config.id === SYSTEM_CONFIG_ID,
    );

    if (!systemConfigExists) {
      const visibleColumns = columns
        .filter((col) => !col.hide)
        .map((col) => ({
          key: col.key,
          label: col.label,
        }));

      const systemConfig = {
        id: SYSTEM_CONFIG_ID,
        configName: SYSTEM_CONFIG_NAME,
        columns: visibleColumns,
        allFilterConditions: [],
        anyFilterConditions: [],
        isActive: true,
        isDefault: true,
        isSystem: true,
        createdDate: new Date().toISOString(),
      };

      configs.unshift(systemConfig);
    } else {
      const visibleColumns = columns
        .filter((col) => !col.hide)
        .map((col) => ({
          key: col.key,
          label: col.label,
        }));

      const systemConfigIndex = configs.findIndex(
        (config) => config.id === SYSTEM_CONFIG_ID,
      );

      configs[systemConfigIndex] = {
        ...configs[systemConfigIndex],
        columns: visibleColumns,
        updatedOn: new Date().toISOString(),
      };
    }

    const userConfigs = configs.filter((config) => !config.isSystem);
    const hasActiveUserConfig = userConfigs.some((config) => config.isActive);

    if (!hasActiveUserConfig) {
      configs = configs.map((config) => ({
        ...config,
        isActive: config.id === SYSTEM_CONFIG_ID,
      }));
    } else {
      configs = configs.map((config) =>
        config.id === SYSTEM_CONFIG_ID
          ? { ...config, isActive: false }
          : config,
      );
    }

    localStorage.setItem(
      `tableConfig_${tableId}_${userId}`,
      JSON.stringify(configs),
    );

    return configs;
  }, [tableId, userId, columns]);

  useEffect(() => {
    const configs = initializeSystemConfig();
    loadExistingConfigs();

    const handleConfigUpdate = (e) => {
      if (
        tableId &&
        e.detail.tableId === tableId &&
        e.detail.userId === userId
      ) {
        loadExistingConfigs();
      }
    };

    window.addEventListener("tableConfigUpdated", handleConfigUpdate);

    return () => {
      window.removeEventListener("tableConfigUpdated", handleConfigUpdate);
    };
  }, [tableId, userId, initializeSystemConfig]);

  const loadExistingConfigs = () => {
    const existingConfigStr = localStorage.getItem(
      `tableConfig_${tableId}_${userId}`,
    );

    if (existingConfigStr) {
      try {
        const parsedConfig = JSON.parse(existingConfigStr);
        const configs = Array.isArray(parsedConfig)
          ? parsedConfig
          : [parsedConfig];
        setExistingConfigs(configs);

        const activeConfig = configs.find((config) => config.isActive);

        if (activeConfig) {
          if (activeConfig.isSystem) {
            setIsSystemConfigActive(true);
            setActiveConfigId(SYSTEM_CONFIG_ID);
            setIsAddNewMode(false);
          } else {
            setIsSystemConfigActive(false);
            loadConfigData(activeConfig);
            setActiveConfigId(activeConfig.id);
            setIsAddNewMode(false);
          }
        } else {
          setActiveConfigId(null);
          setIsAddNewMode(false);
          setIsSystemConfigActive(true);
        }
      } catch (error) {
        console.error("Error parsing existing table config:", error);
        setExistingConfigs([]);
        setIsAddNewMode(false);
        setIsSystemConfigActive(true);
      }
    } else {
      setExistingConfigs([]);
      setIsAddNewMode(false);
      setIsSystemConfigActive(true);
    }
  };

  const loadConfigData = (config) => {
    setListName(config.configName);
    const validColumns = (config.columns || []).filter(
      (col) => col.key && col.key.trim() !== "",
    );

    setSelectedColumns(validColumns);

    const optionValues = [];
    if (config.isDefault) optionValues.push("1");
    if (config.isActive) optionValues.push("2");
    setOptions(optionValues.length > 0 ? optionValues : []);

    setFormData({
      filterConditions:
        config.allFilterConditions && config.allFilterConditions.length > 0
          ? config.allFilterConditions
          : initialFilterConditions,
      anyConditions:
        config.anyFilterConditions && config.anyFilterConditions.length > 0
          ? config.anyFilterConditions
          : initialAnyConditions,
    });

    setOriginalConfigName(config.configName);
  };

  const onAddNewConfig = () => {
    setIsAddNewMode(true);
    setListName("");
    setOptions([]);
    setSelectedColumns([]);
    setActiveConfigId(null);
    setOriginalConfigName("");
    setIsSystemConfigActive(false);

    setFormData({
      filterConditions: initialFilterConditions,
      anyConditions: initialAnyConditions,
    });
  };

  const toCamelCase = (str) => {
    return str
      .trim()
      .replace(/\s+/g, " ")
      .split(" ")
      .map((word, index) => {
        if (index === 0) {
          return word.toLowerCase();
        }
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join("");
  };

  const onSaveConfigList = () => {
    if (!listName.trim()) {
      showToast("Please enter a configuration name", "warning");
      return;
    }

    if (selectedColumns.length === 0) {
      showToast("Please select at least one column", "warning");
      return;
    }

    const camelCaseListName = toCamelCase(listName);

    const existingConfigStr = localStorage.getItem(
      `tableConfig_${tableId}_${userId}`,
    );
    let existingConfigs = [];

    if (existingConfigStr) {
      try {
        const parsedConfig = JSON.parse(existingConfigStr);
        existingConfigs = Array.isArray(parsedConfig)
          ? parsedConfig
          : [parsedConfig];

        const isDuplicate = existingConfigs.some(
          (config) =>
            config.configName.toLowerCase() === camelCaseListName.toLowerCase(),
        );

        if (isDuplicate) {
          showToast(
            `Configuration with name "${camelCaseListName}" already exists`,
            "error",
          );
          return;
        }
      } catch (error) {
        console.error("Error parsing existing table config:", error);
      }
    }

    const isDefault = options.includes("1");
    // CLEAN FILTER CONDITIONS BEFORE SAVING
    const cleanAll = (formData?.filterConditions || []).filter(
      (c) => c.filterColunm && c.operator,
    );

    const cleanAny = (formData?.anyConditions || []).filter(
      (c) => c.filterColunm && c.operator,
    );

    const newConfig = {
      id: Date.now(),
      configName: camelCaseListName,
      columns: selectedColumns,
      // allFilterConditions: formData.filterConditions,
      // anyFilterConditions: formData.anyConditions,
      allFilterConditions: cleanAll,
      anyFilterConditions: cleanAny,
      isActive: true,
      isDefault,
      isSystem: false,
      createdDate: new Date().toISOString(),
    };

    const updatedConfigs = existingConfigs.map((config) => ({
      ...config,
      isActive: false,
      isDefault: isDefault ? false : config.isDefault,
    }));

    updatedConfigs.push(newConfig);

    localStorage.setItem(
      `tableConfig_${tableId}_${userId}`,
      JSON.stringify(updatedConfigs),
    );

    if (onFilterUpdate) {
      onFilterUpdate();
    }

    const event = new CustomEvent("tableConfigUpdated", {
      detail: { tableId, userId },
    });
    window.dispatchEvent(event);

    // if (serverFiltering && onServerFilterChange) {
    //   onServerFilterChange({
    //     allFilterConditions: newConfig.allFilterConditions || [],
    //     anyFilterConditions: newConfig.anyFilterConditions || [],
    //     columns: newConfig.columns || [],
    //     configName: newConfig.configName,
    //     configId: newConfig.id,
    //   });
    // }
    if (serverFiltering && onServerFilterChange) {
      const cleanAll = (newConfig?.allFilterConditions || []).filter(
        (c) => c.filterColunm && c.operator,
      );

      const cleanAny = (newConfig?.anyFilterConditions || []).filter(
        (c) => c.filterColunm && c.operator,
      );

      const payload = {
        columns: newConfig.columns || [],
        configName: newConfig.configName,
        configId: newConfig.id,
        allFilterConditions: cleanAll,
        anyFilterConditions: cleanAny,
      };

      onServerFilterChange(payload);
    }

    setIsAddNewMode(false);
    setIsSystemConfigActive(false);
    loadExistingConfigs();
    showToast("Configuration saved successfully", "success");
  };

  const deleteConfig = (configToDelete) => {
    if (configToDelete.isSystem) {
      showToast("System configuration cannot be deleted", "error");
      return;
    }

    const existingConfigStr = localStorage.getItem(
      `tableConfig_${tableId}_${userId}`,
    );
    let existingConfigs = [];

    if (existingConfigStr) {
      try {
        const parsedConfig = JSON.parse(existingConfigStr);
        existingConfigs = Array.isArray(parsedConfig)
          ? parsedConfig
          : [parsedConfig];
      } catch (error) {
        console.error("Error parsing existing table config:", error);
      }
    }

    const updatedConfigs = existingConfigs.filter(
      (config) => config.id !== configToDelete.id,
    );

    const wasActive = configToDelete.isActive;
    const userConfigs = updatedConfigs.filter((config) => !config.isSystem);

    if (wasActive && userConfigs.length > 0) {
      updatedConfigs.forEach((config) => {
        if (!config.isSystem && config.id === userConfigs[0].id) {
          config.isActive = true;
        }
      });
    } else if (wasActive || userConfigs.length === 0) {
      updatedConfigs.forEach((config) => {
        if (config.isSystem) {
          config.isActive = true;
        }
      });
    }

    localStorage.setItem(
      `tableConfig_${tableId}_${userId}`,
      JSON.stringify(updatedConfigs),
    );

    if (onFilterUpdate) {
      onFilterUpdate();
    }

    const event = new CustomEvent("tableConfigUpdated", {
      detail: { tableId, userId },
    });
    window.dispatchEvent(event);

    if (serverFiltering && onServerFilterChange) {
      const newActiveConfig = updatedConfigs.find((config) => config.isActive);
      if (newActiveConfig) {
        onServerFilterChange({
          allFilterConditions: newActiveConfig.allFilterConditions || [],
          anyFilterConditions: newActiveConfig.anyFilterConditions || [],
          columns: newActiveConfig.columns || [],
          configName: newActiveConfig.configName,
          configId: newActiveConfig.id,
        });
      }
    }

    loadExistingConfigs();
    showToast("Configuration deleted successfully", "success");
  };

  const activeConfig = (configToToggle) => {
    const existingConfigStr = localStorage.getItem(
      `tableConfig_${tableId}_${userId}`,
    );
    let existingConfigs = [];

    if (existingConfigStr) {
      try {
        const parsedConfig = JSON.parse(existingConfigStr);
        existingConfigs = Array.isArray(parsedConfig)
          ? parsedConfig
          : [parsedConfig];
      } catch (error) {
        console.error("Error parsing existing table config:", error);
      }
    }

    const isCurrentlyActive = configToToggle.isActive;

    const updatedConfigs = existingConfigs.map((config) => ({
      ...config,
      isActive: config.id === configToToggle.id ? !isCurrentlyActive : false,
    }));

    localStorage.setItem(
      `tableConfig_${tableId}_${userId}`,
      JSON.stringify(updatedConfigs),
    );

    loadExistingConfigs();

    const event = new CustomEvent("tableConfigUpdated", {
      detail: { tableId, userId },
    });
    window.dispatchEvent(event);

    if (serverFiltering && onServerFilterChange) {
      const newlyActiveConfig = updatedConfigs.find((c) => c.isActive);
      onServerFilterChange(
        newlyActiveConfig
          ? {
              allFilterConditions: newlyActiveConfig.allFilterConditions || [],
              anyFilterConditions: newlyActiveConfig.anyFilterConditions || [],
              columns: newlyActiveConfig.columns || [],
              configName: newlyActiveConfig.configName,
              configId: newlyActiveConfig.id,
            }
          : {
              allFilterConditions: [],
              anyFilterConditions: [],
              columns: [],
              configName: "",
              configId: null,
            },
      );
    }

    if (isCurrentlyActive) {
      showToast("Configuration deactivated successfully", "danger");
    } else {
      showToast("Configuration activated successfully", "success");
    }
  };

  const onCancelChanges = () => {
    if (isAddNewMode) {
      // If in add new mode, go back to the previous active config
      const activeConfig = existingConfigs.find((config) => config.isActive);
      if (activeConfig && !activeConfig.isSystem) {
        loadConfigData(activeConfig);
        setActiveConfigId(activeConfig.id);
        setIsAddNewMode(false);
        setIsSystemConfigActive(false);
      } else if (activeConfig && activeConfig.isSystem) {
        setIsSystemConfigActive(true);
        setActiveConfigId(SYSTEM_CONFIG_ID);
        setIsAddNewMode(false);
      } else {
        setListName("");
        setOptions([]);
        setSelectedColumns([]);
        setFormData({
          filterConditions: initialFilterConditions,
          anyConditions: initialAnyConditions,
        });
        setActiveConfigId(null);
        setOriginalConfigName("");
        setIsAddNewMode(false);
        setIsSystemConfigActive(true);
      }
    } else {
      // If updating existing config, close the drawer
      if (onDrawerClose) {
        onDrawerClose();
      }
    }
  };

  const onUpdateConfigList = () => {
    if (!listName.trim()) {
      showToast("Please enter a configuration name", "warning");
      return;
    }

    if (selectedColumns.length === 0) {
      showToast("Please select at least one column", "warning");
      return;
    }

    const existingConfigStr = localStorage.getItem(
      `tableConfig_${tableId}_${userId}`,
    );

    let existingConfigs = [];
    if (existingConfigStr) {
      try {
        const parsedConfig = JSON.parse(existingConfigStr);
        existingConfigs = Array.isArray(parsedConfig)
          ? parsedConfig
          : [parsedConfig];
      } catch (error) {
        console.error("Error parsing existing table config:", error);
      }
    }

    const duplicateNameIndex = existingConfigs.findIndex(
      (config) =>
        config.configName === listName &&
        config.configName !== originalConfigName,
    );

    if (duplicateNameIndex !== -1) {
      showToast(
        "Configuration name already exists. Please choose a different name.",
        "error",
      );
      return;
    }

    const configToUpdate = existingConfigs.find(
      (config) => config.configName === originalConfigName,
    );
    // CLEAN FILTER CONDITIONS BEFORE SAVING
    const cleanAll = (formData?.filterConditions || []).filter(
      (c) => c.filterColunm && c.operator,
    );

    const cleanAny = (formData?.anyConditions || []).filter(
      (c) => c.filterColunm && c.operator,
    );

    if (configToUpdate) {
      const updatedConfig = {
        ...configToUpdate,
        configName: listName,
        isActive: options.includes("2"),
        isDefault: options.includes("1"),
        columns: selectedColumns,
        // allFilterConditions: formData.filterConditions,
        // anyFilterConditions: formData.anyConditions,
        allFilterConditions: cleanAll,
        anyFilterConditions: cleanAny,
        updatedDate: new Date().toISOString(),
      };

      const index = existingConfigs.findIndex(
        (config) => config.id === configToUpdate.id,
      );

      if (index !== -1) {
        existingConfigs[index] = updatedConfig;

        localStorage.setItem(
          `tableConfig_${tableId}_${userId}`,
          JSON.stringify(existingConfigs),
        );

        const event = new CustomEvent("tableConfigUpdated", {
          detail: { tableId, userId },
        });
        window.dispatchEvent(event);

        // if (serverFiltering && onServerFilterChange && updatedConfig.isActive) {
        //   onServerFilterChange({
        //     allFilterConditions: updatedConfig.allFilterConditions || [],
        //     anyFilterConditions: updatedConfig.anyFilterConditions || [],
        //     columns: updatedConfig.columns || [],
        //     configName: updatedConfig.configName,
        //     configId: updatedConfig.id,
        //   });
        // }
        if (serverFiltering && onServerFilterChange && updatedConfig.isActive) {
          const cleanAll = (updatedConfig?.allFilterConditions || []).filter(
            (c) => c.filterColunm && c.operator,
          );

          const cleanAny = (updatedConfig?.anyFilterConditions || []).filter(
            (c) => c.filterColunm && c.operator,
          );

          const payload = {
            columns: updatedConfig.columns || [],
            configName: updatedConfig.configName,
            configId: updatedConfig.id,
            allFilterConditions: cleanAll,
            anyFilterConditions: cleanAny,
          };

          // Add only if values exist
          // if (cleanAll?.length > 0) {
          //   payload.allFilterConditions = cleanAll;
          // }

          // if (cleanAny?.length > 0) {
          //   payload.anyFilterConditions = cleanAny;
          // }

          onServerFilterChange(payload);
        }

        loadConfigData(updatedConfig);
        setOriginalConfigName(updatedConfig.configName);

        if (onFilterUpdate) {
          onFilterUpdate();
        }
        showToast("Configuration updated successfully", "success");
        onDrawerClose();
      } else {
        showToast("Configuration not found", "error");
      }
    } else {
      showToast("Configuration not found", "error");
    }
  };
  // it is used to disable the options when there is same operator and column in two conditions
  const getDisabledOperatorsForRow = (conditionsArray, currentIndex) => {
    const { filterColunm } = conditionsArray[currentIndex];

    if (!filterColunm) return [];

    return conditionsArray
      .filter(
        (cond, idx) =>
          idx !== currentIndex &&
          cond.filterColunm === filterColunm &&
          cond.operator, // <-- only count selected operators
      )
      .map((cond) => cond.operator);
  };

  const renderConditionFields = (condition, index, isAllConditions = true) => {
    const conditionsArray = isAllConditions
      ? formData.filterConditions
      : formData.anyConditions;

    return (
      <>
        <FormFieldSet
          title="Column"
          placeholder="Select Column"
          type="select"
          options={columns
            .filter((col) => col.key)
            .map((col) => ({
              label: col.label,
              value: col.labelKey || col.key,
            }))}
          value={condition.filterColunm || ""}
          onChange={(value) => {
            conditionsArray[index].filterColunm = value;
            conditionsArray[index].filterValue = "";
            conditionsArray[index].operator = "";

            const selectedColumn =
              columns.find((col) => (col.labelKey || col.key) === value) || {};

            determineColumnDataTypeEnhanced(
              selectedColumn,
              rows,
              conditionsArray[index],
              null,
            );

            setFormData((prev) => ({ ...prev }));
            // setFormData({ ...formData });
          }}
        />
        <div>
          <FormFieldSet
            title="Operator"
            placeholder="Select Operator"
            type="select"
            options={(() => {
              const operators = getFilterOperatorsByDataType(
                conditionsArray[index].dataType,
              );
              const disabledOps = getDisabledOperatorsForRow(
                conditionsArray,
                index,
              );
              return operators.map((op) => ({
                ...op,
                isDisabled: disabledOps.includes(op.value) && isAllConditions, // it disables the option only for allconditions filter when there is same operator and column
              }));
            })()}
            value={condition.operator || ""}
            onChange={(value) => {
              conditionsArray[index].operator = value;
              setFormData({ ...formData });
            }}
            disabled={!conditionsArray[index].filterColunm}
          />
        </div>
        <div className="w-full">
          <FormFieldSet
            title="Value"
            placeholder="Enter value"
            type={(() => {
              const dataType = conditionsArray[index].dataType;

              switch (dataType) {
                case "date":
                  return "datepicker";
                case "boolean":
                  return "select";
                case "enum":
                  return "select";
                case "array":
                  return "select";
                case "number":
                case "integer":
                case "currency":
                case "percentage":
                  return "text";
                case "email":
                  return "text";
                case "url":
                  return "text";
                case "phone":
                  return "phone";
                default:
                  return "text";
              }
            })()}
            options={(() => {
              const dataType = conditionsArray[index].dataType;
              const selectedColumn =
                columns.find(
                  (col) =>
                    (col.labelKey || col.key) ===
                    conditionsArray[index].filterColunm,
                ) || {};

              if (dataType === "enum" && selectedColumn.dataValue) {
                return selectedColumn.dataValue;
              }

              if (dataType === "array") {
                if (Array.isArray(selectedColumn.dataValue)) {
                  return selectedColumn.dataValue.map((item) => {
                    if (
                      item &&
                      typeof item === "object" &&
                      "label" in item &&
                      "value" in item
                    ) {
                      return item;
                    }

                    const itemStr = String(item);
                    const valueStr = itemStr.replace(/\s+/g, "_");

                    return {
                      label: itemStr,
                      value: valueStr,
                    };
                  });
                }
                return selectedColumn.dataValue;
              }

              if (dataType === "boolean") {
                return [
                  { label: "True", value: true },
                  { label: "False", value: false },
                ];
              }

              return [];
            })()}
            value={
              condition.filterValue ||
              (conditionsArray[index].dataType === "array" ? [] : "")
            }
            onChange={(value) => {
              conditionsArray[index].filterValue = value;
              setFormData({ ...formData });
            }}
            disabled={!conditionsArray[index].operator}
            multiple={conditionsArray[index].dataType === "array"}
          />
        </div>
      </>
    );
  };

  const userConfigs = existingConfigs.filter((config) => !config.isSystem);
  const hasUserConfigs = userConfigs.length > 0;

  return (
    <div
      className={`${
        hasUserConfigs
          ? "flex flex-col xl:grid grid-cols-[4fr_10fr] overflow-auto"
          : "flex"
      }  gap-10 w-full overflow-auto`}
    >
      {hasUserConfigs && (
        <div className="max-h-[200px] xl:max-h-full overflow-auto shadow-2xl">
          <div className="">
            <div className="flex justify-between items-center px-3 py-2">
              <PageTitle title="Column Configurations List" tag="h6" />
              {hasUserConfigs && (
                <Button
                  title="Add New"
                  icon="add"
                  size="sm"
                  variant="outlined"
                  onClick={onAddNewConfig}
                />
              )}
            </div>
            <div className="my-3 xl:h-80 overflow-auto">
              {/* Only show system config if no user configs exist */}
              {/* {!hasUserConfigs && (
              <div
                className={`border-b border-gray-300 flex justify-between items-center py-1 px-3 ${
                  isSystemConfigActive ? "bg-blue-100" : "bg-gray-100"
                }`}
              >
                <div className="flex-1 text-sm">System Generated</div>
                <div className="flex gap-1 items-center">
                  <Button
                    variant="text"
                    type="icon"
                    icon={
                      isSystemConfigActive
                        ? "check_small"
                        : "check_indeterminate_small"
                    }
                    size="sm"
                    color={isSystemConfigActive ? "success" : "dark"}
                    onClick={() => {
                      const systemConfig = existingConfigs.find(
                        (config) => config.isSystem
                      );
                      if (systemConfig) {
                        activeConfig(systemConfig);
                      }
                    }}
                  />
                </div>
              </div>
            )} */}

              {/* User Configs */}
              {userConfigs.map((config, index) => {
                return (
                  <div
                    key={index}
                    className={`border-b border-gray-300 flex justify-between items-center py-1 px-3 ${
                      config.id === activeConfigId && !isAddNewMode
                        ? "bg-blue-100"
                        : "bg-gray-100"
                    }`}
                  >
                    <div className="flex-1 text-sm">
                      {keyToTitle(config.configName)}
                    </div>
                    <div className="flex gap-1 items-center">
                      <Button
                        variant="text"
                        type="icon"
                        icon={
                          config.isActive
                            ? "check_small"
                            : "check_indeterminate_small"
                        }
                        size="sm"
                        color={config.isActive ? "success" : "dark"}
                        onClick={() => activeConfig(config)}
                      />

                      {!config.isActive && (
                        <Button
                          variant="text"
                          title="delete"
                          type="icon"
                          icon="delete"
                          size="xs"
                          color="danger"
                          onClick={() => deleteConfig(config)}
                        />
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}

      <div className="flex flex-col gap-3 flex-1 overflow-hidden">
        {isSystemConfigActive && !isAddNewMode && !hasUserConfigs ? (
          <div className="flex flex-col items-center justify-center flex-1 gap-4">
            <div className="text-center">
              <PageTitle
                title="System Generated Configuration"
                className="justify-center"
                tag="h5"
              />
              <p className="text-gray-600 mt-2">
                This is the default system configuration. Click below to create
                your custom configuration.
              </p>
            </div>
            <Button
              title="Add New Config"
              icon="add"
              size="md"
              onClick={onAddNewConfig}
            />
          </div>
        ) : (
          <>
            <div className="border border-gray-200 p-5 rounded-md">
              <PageTitle
                title={
                  isAddNewMode
                    ? "Create New Column Configuration List"
                    : "Active Configuration"
                }
                tag="h6"
              />
              <div className="grid grid-cols-6 gap-5 mt-3">
                <div className="col-span-4">
                  <FormFieldSet
                    type="text"
                    placeholder="List Name"
                    title="List Name"
                    value={listName}
                    onChange={setListName}
                    disabled={false}
                  />
                </div>
                <div className="col-span-2">
                  <FormFieldSet
                    title=""
                    type="checkbox"
                    options={[
                      { label: "Set as Default", value: "1" },
                      { label: "Set As Active", value: "2" },
                    ]}
                    multiple
                    values={options}
                    onChange={(values) => setOptions(values)}
                    disabled={false}
                  />
                </div>

                <div className="col-span-6">
                  <ColumnSelector
                    columns={colunmsCleanKeys}
                    placeholder={"Select columns"}
                    rounded={"rounded"}
                    showSearch
                    selectedColumns={selectedColumns}
                    onChange={setSelectedColumns}
                    disabled={false}
                  />
                </div>
              </div>
            </div>
            <div className="flex flex-col flex-1 gap-3 overflow-auto">
              <div className="border border-gray-200 p-5 rounded-md">
                <PageTitle title="Search In" tag="h6" />
                <LoopFieldsSet
                  title="All Conditions"
                  titleConfig={{
                    tag: "h6",
                  }}
                  data={formData.filterConditions}
                  onAdd={addFilterCondition}
                  onRemove={removeFilterCondition}
                  minItems={1}
                  maxItems={5}
                  gridCols="grid-cols-[repeat(3,1fr)_40px]"
                  renderFields={(condition, index) =>
                    renderConditionFields(condition, index, true)
                  }
                  disabled={false}
                />
              </div>

              <div className="border border-gray-200 p-5 rounded-md">
                <PageTitle title="Search In" tag="h6" />
                <LoopFieldsSet
                  title="Any Condition"
                  titleConfig={{
                    tag: "h6",
                  }}
                  data={formData.anyConditions}
                  onAdd={addAnyCondition}
                  onRemove={removeAnyCondition}
                  minItems={1}
                  maxItems={5}
                  gridCols="grid-cols-[repeat(3,1fr)_40px]"
                  renderFields={(condition, index) =>
                    renderConditionFields(condition, index, false)
                  }
                  disabled={false}
                />
              </div>
            </div>
            <div className="col-span-6 mb-4 mx-3">
              {isAddNewMode ? (
                <div className="flex justify-end gap-2">
                  <Button
                    title={"Cancel"}
                    icon={"close"}
                    variant="text"
                    onClick={onCancelChanges}
                    size="sm"
                    color="black"
                  />
                  <Button
                    title={"Save"}
                    icon={"save"}
                    onClick={onSaveConfigList}
                    size="sm"
                  />
                </div>
              ) : (
                activeConfigId && (
                  <div className="flex justify-end gap-2">
                    <Button
                      title={"Cancel"}
                      icon={"close"}
                      variant="text"
                      onClick={onCancelChanges}
                      size="sm"
                      color="black"
                    />
                    <Button
                      title={"Update"}
                      icon={"save"}
                      onClick={onUpdateConfigList}
                      size="sm"
                    />
                  </div>
                )
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default TableDrawerData;
